import { SchemaDefinition } from "../validator/schema-definition-interface";

/**
 * The schema definition for the stored service note object.
 */
export const storedServiceNoteSchema: SchemaDefinition = {
	Name: 'stored-service-note',
	Properties: {
		Note: { Type: 'string' },
		Type: { Type: 'string' },
		Timestamp: { Type: 'Date' }
	}
}